import React, { createContext, useContext } from 'react';
import ptBR from './pt-BR';
import en from './en';

export const locales = {
  'pt-BR': ptBR,
  en,
};

export const getLocaleFromPathname = (pathname) => pathname === '/en/' || pathname === '/en' ? 'en' : 'pt-BR';

const LocaleContext = createContext('pt-BR');

export const LocaleProvider = ({ children, locale = getLocaleFromPathname(window.location.pathname) }) => (
  <LocaleContext.Provider value={locale}>{children}</LocaleContext.Provider>
);

export const useI18n = () => {
  const locale = useContext(LocaleContext);
  return { locale, t: locales[locale] || ptBR };
};
